import { render, staticRenderFns } from "./DropoffRequested.vue?vue&type=template&id=2406b2aa&scoped=true"
import script from "./DropoffRequested.vue?vue&type=script&lang=ts"
export * from "./DropoffRequested.vue?vue&type=script&lang=ts"
import style0 from "./DropoffRequested.vue?vue&type=style&index=0&id=2406b2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406b2aa",
  null
  
)

export default component.exports